Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch('Listing.customBeforeFetch');
}

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    rEvent.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    rEvent.dispatch('FilterBubbles.added');
}

FilterBubbles.get = function (key, value) {
    return Filter.filterInputs.filter(function () {
        if (this.name == 'filter[rating_avg]' && (['0_100', ''].includes(this.value))) {
            return false
        }

        switch (this.tagName.toLowerCase()) {
            case "select":
                return this.name == key;

            case "input":
                return this.name == key && this.value == value;
        }
    });
}

Eshop.alert = function (msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: checkResolution('cxs;xs') ? 'bottom' : 'top'
        },
        gap: 2,
        delay: 4500,
        mouse_over: 'pause',
        offset: {
            y: checkResolution('cxs;xs') ? 15 : 85,
            x: 0
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
            '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
            '<i class="ico ico-close" aria-hidden="true"></i>' +
            '</button>' +
            '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

rEvent.on('Cart.product.before_add', function (form) {
    $(form).find('.c-btn--cart').addClass('is-loading');
    $(form).parents('.c-btn--cart').addClass('is-loading');
});

rEvent.on('Cart.product.after_add', function (response) {
    $('.c-btn--cart.is-loading').removeClass('is-loading');
});

rEvent.on('Listing.customBeforeFetch', function() {
    if ($('.listing__holder').length) {
        $('.listing__holder').addClass('is-loading');
    }
    if ($('.c-msg.is-empty.listing').length) {
        $('.c-msg.is-empty.listing').addClass('is-loading');
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    requestAnimationFrame(() => {
        if ($('.listing__holder').length) {
            $('.listing__holder').removeClass('is-loading');
        }

        if ($('.pager__load').length) {
            $('.pager__load').removeClass('is-loading');
        }
    })

    if ($('.pager__load').length && $('.pager__load').hasClass('is-loading')) {
        $('.pager__load').removeClass('is-loading');
    }

    $('.js-stars').each(function () {
        createStars($(this), {
            readOnly: true,
            starSize: parseInt($(this).attr('data-size')) || 16
        });
    });

    updatePagingText(data);

    bLazy.revalidate();
    setTimeout(() => {
        bLazy.revalidate();
    }, 100);
});

function updatePagingText(data) {
    if (!data) {
        return;
    }

    const $start = $('.js-paginator-start'),
        page = data.page,
        perPage = data.perPage,
        visiblePages = $start.parents('.listing').length;

    $start.text(page * perPage - visiblePages * perPage + 1);
}

$(function () {
    setTimeout(function() {
        if ($('.js-form-contact').length) {
            $('.js-form-contact').validate().settings.rules.phone = {
                phone: true,
            };
        }
    }, 0);

    $(document).on('click', '.pager__load', function () {
        $(this).addClass('is-loading');
    });
});


var filterElem = document.getElementById("filter");

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        var categoryId = e.detail.category_id;

        document.getElementById('filterCategoryId').value = categoryId;
        Filter.submit();
    });

    filterElem.addEventListener("category.updated", function (e) {
        var category = e.detail.category;
        var headElem = document.getElementsByTagName('h1')[0];
        var heading = headElem.innerText;

        if (headElem.dataset.original === undefined) {
            headElem.dataset.original = heading;
        }

        headElem.innerText = headElem.dataset.original;
        if (category) {
            headElem.innerText += " - " + category.name;
        }
    });
}